import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { IAdFoxBannerOnErrorError } from '@cian/adfox-component';
import { GenericError } from '@cian/peperrors/shared';
import { useSelector } from 'react-redux';
import { trackBuilderLinkEvent } from './tracking';
import { selectBuilderLinkExperimentActive } from '../../selectors/builderLink';
import { getNewbuildingId } from '../../selectors/newbuilding';
import { useApplicationContext } from '../../utils/withApplicationContext';
import { AdfoxContainer } from '../Adfox';

export function BuilderLinkContainer() {
  const { logger, config } = useApplicationContext();
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [isShowed, setIsShowed] = React.useState(false);

  const isEnabled = config.get('Adfox.BuilderLink.Enabled');

  const newbuildingId = useSelector(getNewbuildingId);
  const active = useSelector(selectBuilderLinkExperimentActive);

  const [hidden, setHidden] = React.useState(false);

  const handleClick = React.useCallback(() => {
    trackBuilderLinkEvent({
      newbuildingId,
      action: 'Click',
    });
  }, [newbuildingId]);

  const handleLoad = React.useCallback(() => {
    setIsLoaded(true);

    if (isShowed) {
      trackBuilderLinkEvent({
        newbuildingId,
        action: 'Show',
      });
    }
  }, [newbuildingId, isShowed, setIsLoaded]);

  const handleView = React.useCallback(() => {
    setIsShowed(true);

    if (isLoaded) {
      trackBuilderLinkEvent({
        newbuildingId,
        action: 'Show',
      });
    }
  }, [newbuildingId, isLoaded, setIsShowed]);

  const handleStub = React.useCallback(() => {
    setHidden(true);
  }, [setHidden]);

  const handleError = React.useCallback(
    (error: IAdFoxBannerOnErrorError) => {
      setHidden(true);

      logger.error(
        new GenericError({
          domain: 'AdfoxBuilderLink',
          type: 'Adfox',
          message: error.type,
          details: { newbuildingId },
        }),
      );
    },
    [setHidden, logger, newbuildingId],
  );

  if (!active || hidden || !isEnabled) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleView} percentVisible={0.5} triggerOnce>
      <div onClick={handleClick}>
        <AdfoxContainer
          params={{ p1: 'czyqz', p2: 'iqzd', puid40: String(newbuildingId) }}
          width="1px"
          height={1}
          onStub={handleStub}
          onLoad={handleLoad}
          onError={handleError}
          lazyLoad={{
            fetchMargin: 100,
            mobileScaling: 1,
          }}
        />
      </div>
    </ActionAfterViewObserver>
  );
}
